var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-notification',{staticClass:"loading-box",attrs:{"closable":false,"data-test":"loading","aria-busy":"true"}},[_c('b-loading',{attrs:{"active":true,"is-full-page":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }